import { render, staticRenderFns } from "./Ams.vue?vue&type=template&id=0a248d18&scoped=true&"
import script from "./Ams.vue?vue&type=script&lang=js&"
export * from "./Ams.vue?vue&type=script&lang=js&"
import style0 from "./Ams.vue?vue&type=style&index=0&id=0a248d18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a248d18",
  null
  
)

export default component.exports